import Image, { type StaticImageData } from 'next/image';
import { type ReactNode, useId } from 'react';
import styles from './MembershipIncludes.module.scss';

type Props = {
  label: ReactNode;
  rows: {
    body: ReactNode;
    src: StaticImageData;
    title: ReactNode;
  }[];
};

// https://www.figma.com/design/A5nCSpBmbtpzkWhmnn2uoV/Member-Deals-Product-Updates?node-id=1-4708&m=dev
export default function MembershipIncludes({ label, rows }: Props) {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} className={styles.root}>
      <p className={styles.sectionLabel} id={headingId}>
        {label}
      </p>
      <ul className={styles.list}>
        {rows.map((row, index) => (
          <li key={index} className={styles.row}>
            <Image alt="" className={styles.thumbnail} height={72} src={row.src} width={72} />
            <div className={styles.copy}>
              <p className={styles.rowTitle}>{row.title}</p>
              <p className={styles.rowBody}>{row.body}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
